import { C, SHADOWS } from "../lib/theme";
import { Icon } from "./Icon";

const KIND = {
  primary: { bg: C.hunter, fg: C.dust, shadow: SHADOWS.cta },
  dust: { bg: C.dust, fg: C.hunter },
  outline: { bg: "transparent", fg: C.charcoal, border: `1.5px solid ${C.dustDk}` },
  ghost: { bg: "transparent", fg: C.hunter },
  danger: { bg: C.red, fg: C.white },
};

const SIZE = {
  sm: { p: "6px 12px", fs: 12 },
  md: { p: "9px 16px", fs: 13 },
  lg: { p: "12px 22px", fs: 14 },
};

export function Btn({ children, kind = "primary", size = "md", icon, onClick, full, disabled, type = "button" }) {
  const st = KIND[kind] || KIND.primary;
  const sz = SIZE[size] || SIZE.md;
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      style={{
        background: st.bg,
        color: st.fg,
        border: st.border || "none",
        borderRadius: 12,
        padding: sz.p,
        fontSize: sz.fs,
        fontWeight: 800,
        cursor: disabled ? "not-allowed" : "pointer",
        opacity: disabled ? 0.55 : 1,
        display: "inline-flex",
        alignItems: "center",
        gap: 6,
        width: full ? "100%" : undefined,
        justifyContent: "center",
        whiteSpace: "nowrap",
        fontFamily: "inherit",
        boxShadow: st.shadow || "none",
        transition: "transform .08s ease",
      }}
    >
      {icon && <Icon name={icon} size={sz.fs + 2} color={st.fg} strokeWidth={2} />}
      {children}
    </button>
  );
}
